import Vue from 'vue'
import Router from 'vue-router'
import MainView from "./views/MainView"
import LoginView from "./views/LoginView"
import DashboardView from "./views/DashboardView"
import NotFoundView from "./views/NotFoundView"
import ConfigurationView from "./views/ConfigurationView"
import PanelReadingsView from "./views/PanelReadingsView"
import CountersView from "./views/CountersView"
import UtilsView from "./views/UtilsView"

Vue.use(Router)

export default new Router({
  mode: 'history',
  base: process.env.BASE_URL,
  routes: [
    {
      path: '/login',
      component: LoginView
    },
    {
      path: '/',
      component: MainView,
      children: [
        {
          path: '/dashboard',
          component: DashboardView,
          name: 'Estat dels seguidors',
          meta: {description: 'Estat actual dels seguidors solars'}
        },
        {
          path: '/configuration',
          component: ConfigurationView,
          name: 'Configuració',
          meta: {description: 'Configuració del sistema'}
        },
        {
          path: '/readings/:id',
          component: PanelReadingsView
        },
        {
          path: '/counters',
          component: CountersView
        },
        {
          path: '/utils',
          component: UtilsView,
          name: 'Utilitats',
          meta: {description: 'Utilitats'}
        }
      ]
    },
    {
      // Not found handlers
      path: '*',
      component: NotFoundView
    }
  ]
})
